import { createFileRoute, Outlet } from "@tanstack/react-router"

/** Teams: list (`/studio/teams`) and team detail (`/studio/teams/$teamId`). */
export const Route = createFileRoute("/_app/studio/teams")({
  staticData: { titleKey: "nav.items.teams" },
  component: Outlet,
})
